import { render, staticRenderFns } from "./visual-surveillance.vue?vue&type=template&id=0fc8bec3&"
import script from "./visual-surveillance.vue?vue&type=script&lang=js&"
export * from "./visual-surveillance.vue?vue&type=script&lang=js&"
import style0 from "./visual-surveillance.vue?vue&type=style&index=0&id=0fc8bec3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports